import { TableCell, TableHead } from "@rarible_int/anaconda_ui_components"

type CellProps = React.ComponentProps<typeof TableCell>

export function HeaderCell({ children, className }: CellProps) {
  return <TableHead className={className}>{children}</TableHead>
}

export function Cell(props: CellProps) {
  return <TableCell {...props} />
}
